/* global MutationObserver */
jQuery( $ => {
	/**
	 * Creates an observer that listens for changes in the variation chips.
	 * Checks if a variable is selected and triggers the necessary process that shows the relevant subscription plans.
	 * There's a subscription dropdown (.woo-variation-raw-select) that could also be used instead of this selector
	 * but that is being changed dynamically by the plugin which means that neither eventListener nor this observer below was able to detect the value change in it.
	 *
	 */
	const variationLabels = document.querySelector( '.variations_form' );

	if ( variationLabels ) {
		const mutationOptions = {
			attributes: true,
		};

		const subscriptionObserver = new MutationObserver( findActiveVariation );
		subscriptionObserver.observe( variationLabels, mutationOptions );
	}

	$( document ).ready( function() {
		if ( 'true' === getSubscriptionCookie() ) {
			// if cookie existed, clear it
			setSubscriptionCookie( false, 30 );
		}

		setTimeout( () => {
			toggleSubscriptionsCheckbox();
		}, 1200 );
	} );

	$( 'input[name="variation-plan"]' ).on( 'change', function() {
		planCheckboxChange();
	} );

	/**
	 * Checks if there's an active variation that contains subscription plans and then toggles this element's visibility
	 */
	function findActiveVariation() {
		const variationDropdown = $( '.woo-variation-raw-select' );

		if ( ! variationDropdown ) {
			return;
		}

		const selectedVariation = variationDropdown.val();

		const variationAttributes = $( '.button-variable-item' );
		variationAttributes.each( function() {
			const variationValue = $( this ).attr( 'data-value' );
			if ( selectedVariation === variationValue ) {
				togglePlanGroups( selectedVariation );
			}
		} );
	}

	/**
	 * The enhancer plugin has a checkbox by default, on variations that contain subscription plans.
	 * This function enables it so as to remove this unnecessary step.
	 */
	function toggleSubscriptionsCheckbox() {
		const subscriptions = document.querySelectorAll( '.enr-product_level-subscribe-now-wrapper' );
		if ( subscriptions.length > 0 ) {
			if ( false === document.getElementById( 'enr_subscribe_now' ).checked ) {
				setTimeout( () => {
					document.getElementById( 'enr_subscribe_now' ).click();
				}, 1200 );
			}
		}
	}

	/**
	 * Toggles the subscription plan wrapper for the selected variation.
	 *
	 * @param {string} selectedVariation
	 */
	function togglePlanGroups( selectedVariation ) {
		const planGroups = $( '.variation-subscription-plans' );

		if ( ! planGroups ) {
			return false;
		}

		planGroups.each( function() {
			let dataAttr = $( this ).data( 'variation-slug' );

			if ( dataAttr !== selectedVariation ) {
				$( this ).removeClass( 'active' );
				// Uncheck all checkboxes to roll back to first option as well as hide the tab
				// This is happening because there's a hidden dropdown coming from the plugin which defaults to its first option whenever the options are populated
				$( 'input[name="variation-plan"]' ).prop( 'checked', false );
			} else {
				$( this ).addClass( 'active' );

				const selectedOption = $( '#enr_subscribe_plans option:selected' ).val();
				toggleSubscriptionsCheckbox();
				if ( 'undefined' !== typeof selectedOption ) {
					$( this ).find( '.variation-subscription-plans--options-wrapper label input[value="' + selectedOption + '"]' ).prop( 'checked', true );
					planCheckboxChange( selectedOption );
				} else {
					// Check first checkbox now that the options are visible
					$( this ).find( '.variation-subscription-plans--options-wrapper label:first-child input' ).prop( 'checked', true );
				}
			}
			dataAttr = '';
		} );
	}

	/**
	 * Check if there are subscription plans available and then update the dropdown value with the selected plan
	 *
	 * @param {number} selectedOption
	 */
	function planCheckboxChange( selectedOption ) {
		const planOptions = $( 'input[name="variation-plan"]' );

		if ( ! planOptions ) {
			return false;
		}

		if ( selectedOption ) {
			$( 'input[data-plan-id="' + selectedOption + '"]' ).prop( 'checked', true );
			const selectedPlan = $( 'input[data-plan-id="' + selectedOption + '"]' ).text();
			updatePlanDropdown( selectedPlan );
		} else {
			planOptions.each( function() {
				if ( $( this ).is( ':checked' ) ) {
					const selectedPlan = $( this ).val();
					setTimeout( () => {
						updatePlanDropdown( selectedPlan );
					}, 100 );
				}
			} );
		}

		toggleSubscriptionsCheckbox();
	}

	/**
	 * Enhancer plugin uses a hidden dropdown that when changed, updates the price if anything is different for the new option.
	 * This function updates this dropdown based on the newly selected option of our custom checkboxes.
	 *
	 * @param {string} selectedPlan
	 */
	function updatePlanDropdown( selectedPlan ) {
		const dropdownOptions = $( '#enr_subscribe_plans option' );

		if ( ! dropdownOptions.length > 0 ) {
			return false;
		}

		dropdownOptions.each( function() {
			const selectedOption = $( this ).text();

			$( this ).removeAttr( 'selected' );
			if ( selectedOption === selectedPlan ) {
				$( this ).attr( 'selected', 'selected' );
				$( '#enr_subscribe_plans' ).trigger( 'change' );
			}
		} );
	}

	const subscriptionsForm = document.querySelector( '.variations_form' );
	if ( subscriptionsForm ) {
		subscriptionsForm.addEventListener( 'submit', formSubmitted(), false );
	}

	/**
	 * On form submission check if cookie exists and if not, then clear some data
	 */
	function formSubmitted() {
		if ( 'true' === getSubscriptionCookie() ) {
			setSubscriptionCookie( false, 30 );
		} else {
			setSubscriptionCookie( true, 30 );
			clearSubscriptionData();
		}
	}

	/**
	 * Create a cookie to store the subscription value
	 * There was a bug happening after a subscription product was added to the cart and this is used to check status and resetting some values if necessary
	 *
	 * @param {boolean} value        The value to set for it.
	 * @param {number}  daysToExpire Number of days before the cookie expires.
	 */
	function setSubscriptionCookie( value, daysToExpire ) {
		const d = new Date();
		d.setTime( d.getTime() + ( daysToExpire * 24 * 60 * 60 * 1000 ) );
		const expires = 'expires=' + d.toUTCString();
		document.cookie = 'user-has-subscribed=' + value + ';' + expires + ';path=/';
	}

	/**
	 * Get the previously created cookie
	 *
	 */
	function getSubscriptionCookie() {
		const cookie = {};
		document.cookie.split( ';' ).forEach( function( el ) {
			const [ key, value ] = el.split( '=' );
			cookie[ key.trim() ] = value;
		} );
		return cookie[ 'user-has-subscribed' ];
	}

	/**
	 * By default, whenever a form is submitted, the url gets cleared of parameters
	 * There was a bug occuring after adding to cart, where the option was falling back to the first but the pricing showed that of the product added to cart
	 * Another bug on cart addition was that even though the url is getting cleared, a variation chip remained selected.
	 * In general there were many issues there and so this script below clears all values on relevant fields in order to do a soft reset on the product
	 */
	function clearSubscriptionData() {
		// Check if url has any parameters
		const url = window.location.href;
		const arr = url.split( '?' );
		if ( arr.length > 1 && arr[ 1 ] !== '' ) {
			// A parameter on the url is a correct indication so it's safe to abort
			return;
		}

		// Finally resetting values
		$( 'input[name="variation-plan"]' ).prop( 'checked', false );
		$( '.woo-variation-raw-select' ).val( '' );
		$( '.variation-subscription-plans--options-wrapper label:first-child > input[name="variation-plan"]' ).click();
		$( '.woo-variation-raw-select' ).trigger( 'change' );
		$( '#enr_subscribe_plans option:selected' ).removeAttr( 'selected' );
		$( '#enr_subscribe_plans' ).val( '' ).trigger( 'change' );
		$( '.woo-variation-raw-select option:selected' ).removeAttr( 'selected' );
		$( '.woo-variation-raw-select' ).val( '' ).trigger( 'change' );
		$( '.variation-subscription-plans' ).removeClass( 'active' );
		$( '.button-variable-item' ).removeClass( 'selected' );
		$( '.enr-product_level-subscribe-now-wrapper' ).remove();
	}
} );
